module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('br', {
    staticClass: "hidden-sm hidden-xs"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 4,
        stickyTop: 1
      }),
      expression: "{ zIndex: 4, stickyTop: 1 }"
    }],
    staticClass: "progress",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "progress-bar",
    class: {
      'progress-bar-warning': !_vm.profileStatus.IsProfileReady, 'progress-bar-info': _vm.profileStatus.IsProfileReady
    },
    style: ({
      width: _vm.profileStatus.CompletePct + '%'
    }),
    attrs: {
      "role": "progressbar"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.profileStatus.CurrentStatus) + " "), (!_vm.profileStatus.IsProfileReady) ? _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "font-size": "14px",
      "color": "#8f47a4"
    },
    on: {
      "click": function($event) {
        _vm.showPopup()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs hidden-xs"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/about"
    }
  }, [_c('a', [_vm._v("About Me")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/petpreferences"
    }
  }, [_c('a', [_vm._v("Pet Preferences")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/servicerates"
    }
  }, [_c('a', [_vm._v("Service Rates")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/calendar"
    }
  }, [_c('a', [_vm._v("Calendar")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs hidden-sm hidden-md hidden-lg"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/about"
    }
  }, [_c('a', [_vm._v("About")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/petpreferences"
    }
  }, [_c('a', [_vm._v("Prefs")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/servicerates"
    }
  }, [_c('a', [_vm._v("Rates")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/sitter-profile-edit/calendar"
    }
  }, [_c('a', [_vm._v("Calendar")])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center hidden-xs"
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" Sitter Profile Setup")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center hidden-sm hidden-md hidden-lg",
    staticStyle: {
      "margin-bottom": "5px",
      "margin-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" Sitter Profile Setup")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d4bf31f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/SitterProfileEdit.vue
// module id = 605
// module chunks = 2